import React from 'react';
import { Modal, TextContainer } from '@superops/ui-design-system';

const NormalModal = (props) => {
  const {
    isOpen,
    toggleOpen,
    title,
    description,
    primaryBtn,
    primaryAction,
    secondaryBtn,
    secondaryAction
  } = props;
  return (
    <Modal
      open={isOpen}
      onClose={() => toggleOpen(false)}
      title={title || 'Add task templates Warning'}
      primaryAction={{
        content: primaryBtn || 'Confirm',
        onAction: primaryAction
      }}
      secondaryActions={[
        {
          content: secondaryBtn || 'Cancel',
          onAction: () => toggleOpen(false)
        }
      ]}
    >
      <Modal.Section>
        <TextContainer>
          <p>
            {description ||
              `Templates with technicians who aren't a part of this project are
          about to be added. Are you sure to proceed? On doing so, there
          will not be any technician associated with those tasks`}
          </p>
        </TextContainer>
      </Modal.Section>
    </Modal>
  );
};

export default NormalModal;
